<template>
  <c-app style="background:url(static/1.jpg) no-repeat center center fixed;-webkit-background-size: cover;-moz-background-size: cover;-o-background-size: cover;background-size: cover;">
    <c-content>
      <section class="sign u-m-auto card card--ghost" >
        <div class="sign__body card card--ghost">
          <!--h1 class="sign__title u-fs-32"><span class="u-bg-grey-light u-color-white"><b>&nbsp;Data&nbsp;Extraction&nbsp;<br />&nbsp;Robot&nbsp;</b></span></h1-->
          <h1 class="sign__title u-fs-32"><span class="u-bg-grey-light u-color-white"><b>&nbsp;DOQUMENT&nbsp;</b></span></h1>
          <h3 class="sign__title u-h4"><span class="u-bg-grey-light u-color-white"><b>&nbsp;data extraction robot&nbsp;</b></span></h3>
          <p class="sign__text"></p>
          <c-form @submit.prevent="validateBeforeSubmit">
            <span class="form-help u-color-danger" v-show="hasGlobalError">{{globalError}}</span>
            <c-form-field>
              <span class="u-bg-grey-light u-color-white">&nbsp;Email:&nbsp;</span>
              <c-form-input type="email" name="login" v-model="login" v-validate="'required'"></c-form-input>
              <span class="form-help u-color-white u-bg-grey-light" v-show="errors.has('login')">Please enter the email used when registering</span>
            </c-form-field>
            <c-form-field>
              <span class="u-bg-grey-light u-color-white">&nbsp;Password:&nbsp;</span>
              <c-form-input type="password" name="password" v-model="password" v-validate="'required'"></c-form-input>
              <span class="form-help u-color-white u-bg-grey-light" v-show="errors.has('password')">Please enter the account password</span>
            </c-form-field>
            <c-form-field>
              <c-level v-show="false">
                <c-form-checkbox label="Remember me" slot="left"></c-form-checkbox>
                <router-link to="/forgot" slot="right" style="display:none">Forgot Password?</router-link>
              </c-level>
            </c-form-field>
            <c-button type="primary" @click.prevent="validateBeforeSubmit" block>Login</c-button>
          </c-form>
        </div>
        <footer class="sign__footer u-text-center">
          <span class="u-fs-12 u-color-white u-bg-grey-light">© {{ new Date().getFullYear() }} Digital Keez</span>
        </footer>
      </section>
    </c-content>
  </c-app>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      login: '',
      password: '',
      globalError: ''
    }
  },
  computed: {
    hasGlobalError: function () {
      return this.globalError !== ''
    }
  },
  methods: {
    performlogin () {
      axios.post(process.env.API + 'login', {
        'username': this.login,
        'password': this.password
      }).then((response) => {
        // login done
        console.log('Login successfull for user ', response.data['name'])

        let role = response.data['role']

        window.sessionStorage.setItem('token', response.data['token'])
        window.sessionStorage.setItem('role', response.data['role'])
        window.sessionStorage.setItem('client', response.data['client'])
        window.sessionStorage.setItem('clientName', response.data['clientName'])
        window.sessionStorage.setItem('name', response.data['name'])

        if (role === 'admin') {
          this.$router.push('/admin')
        } else if (role.startsWith('client')) {
          this.$router.push({name: 'UserHome'})
        } else {
          console.error('Invalid client role - ', role)
          this.globalError = 'Invalid email or wrong password'
        }
      }).catch((reason) => {
        console.error('Could not perform login')
        console.error(reason)
        this.globalError = 'Invalid email or wrong password'
      })
    },
    validateBeforeSubmit () {
      // auth.login()

      this.globalError = ''
      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.performlogin()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue